import React from 'react';
import styles from './PayrollTableData.scss';

const BoldRow = props => {
  const { label, value, accordion = false } = props;

  return (
    <tr className={styles.boldRow}>
      <th>{label}</th>
      <td>
        <span style={{ marginRight: accordion ? '13px' : 0 }}>{value}</span>
      </td>
    </tr>
  );
};

export default BoldRow;
